<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content">

    <div class="modal-header justify-content-end">
        <div>
          <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
        </div>
    </div>

    <div class="modal__body">
      <div class="modal__content mt-3 mb-4" :style="{ gap: '0.5rem' }">
        <form ref="policyFormRef" class="row g-0" style="gap: 0.5rem">
          <div>
           <label for="policyName">Policy Name
            <span class="asterisk-required">*</span>
           </label>
           <input type="text" id="policyName" v-model.trim="trainingPolicy.name" @blur="v$.trainingPolicy.name.$touch"
              class="form-control" placeholder="Name" />
           <span class="form-text text-danger" v-if="v$.trainingPolicy.name.$error">
              Name is required.
           </span>
          </div>

          <div class="mt-2">
            <PolicyGroupSelector
              :groups="groups"
              :initial-group-id="trainingPolicy.policy_group_id"
              :can-create-group="canCreateGroup"
              @group-selected="handleGroupSelection"
              @group-created="handleGroupSelection"
              @create-group-request="$emit('create-group-request', $event)"
            />
          </div>

          <div>
            <label class="form-label policy-type-label">Policy File
              <span class="asterisk-required">*</span>
            </label>

            <div class="btn-group" role="group" aria-label="Policy type selection">
              <button
                type="button"
                class="btn d-inline-flex align-items-center justify-content-center"
                :class="trainingPolicy.type === 'link' ? 'btn-policy-active' : 'btn-policy-inactive'"
                @click="switchType('link')"
              >
                <LinkIcon />
                <span>Link</span>
              </button>

              <button
                type="button"
                class="btn d-inline-flex align-items-center justify-content-center"
                :class="trainingPolicy.type === 'file' ? 'btn-policy-active' : 'btn-policy-inactive'"
                @click="switchType('file')"
              >
                <UploadIcon />
                <span>Upload</span>
              </button>
            </div>
              <div class="mt-2">
                <FileUploader v-show="trainingPolicy.type == 'file'" ref="fileRef" :id="'policy'" @fileListChange="fileHandler" :acceptedFileType="'pdf'" key="file" @blur="v$.trainingPolicy.file.$touch"/>
              </div>
            <input v-show="trainingPolicy.type == 'link'" type="text" id="link" v-model.trim="trainingPolicy.link" @blur="v$.trainingPolicy.file.$touch" @input="trainingPolicy.file = trainingPolicy.link"
              class="form-control mt-2" placeholder="Link" />

            <div class="fileList mx-2" v-show="trainingPolicy.currLink != '' && trainingPolicy.file == ''">
              <div>
                <span class="p-2">{{ truncatedLink(trainingPolicy.currLink) }}</span>
              </div>
            </div>

            <div v-if="v$.trainingPolicy.file.$error">
              <span class="form-text text-danger" v-for="error of v$.trainingPolicy.file.$errors" :key="error.$uid" style="display: block;">
                {{ error.$message }}
              </span>
            </div>
            <span class="form-text text-danger" v-if="showPdfError">
              Please upload a valid PDF file.
            </span>

          </div>

          <div class="g-0 d-row d-flex flex-wrap flex-md-nowrap" style="gap: 0.5rem">
            <div class="w-50 vw-100">
              <label for="attestationRequired" class="form-label">Attestation Required</label>
              <select class="form-select" id="attestationRequired" v-model="trainingPolicy.compulsory">
                <option v-for="attestationRequirement in attestationRequirements" :key="attestationRequirement.value" :value="attestationRequirement.value">
                  {{ attestationRequirement.label }}
                </option>
              </select>
            </div>

            <div class="w-50 vw-100">
              <label for="videoIdSelect" class="form-label">Training Video Link</label>
              <select class="form-select" id="videoIdSelect" v-model="trainingPolicy.videoID">
                <option selected disabled value>Please choose...</option>
                <option v-for="videoOption in videoIDs" :key="videoOption.value" :value="videoOption.value">
                  {{ videoOption.label }}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>
      <div class="modal__action">
        <button class="btn btn-primary" style="text-transform: capitalize;" type="button" :disabled="disableFormButton()" @click="create()">
          {{buttonLbl}}
        </button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, url, helpers } from '@vuelidate/validators'
import FileUploader from '@/components/FileUploader.vue';
import LinkIcon from '@/components/policies/assets/LinkIcon.vue';
import UploadIcon from '@/components/policies/assets/UploadIcon.vue';
import PolicyGroupSelector from './PolicyGroupSelector.vue';


export default{

  components: {
    FileUploader,
    LinkIcon,
    UploadIcon,
    PolicyGroupSelector,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    videoIDs: {
      type: Object,
      required: true,
      default: null,
    },
    data: {
      type: Object,
      required: false,
    },
    groups: { type: Array, required: true },
    canCreateGroup: { type: Boolean, default: false },
  },

  emits: ['create-group-request', 'onChange', 'close'],

  setup () {
    return { v$: useVuelidate() }
  },

  validations() {
      return {
        trainingPolicy: {
          name: { required },
          file: {
            required: helpers.withMessage('Link is required.', required),
            validUrl: helpers.withMessage('Please enter a valid URL (e.g., https://example.com).', function(value) {
              if (this.trainingPolicy.type === 'file') return true;
              if (!value) return true;
              return url.$validator(value);
            })
          },
         },
      }
   },

  data() {
    return {
      state: this.dialog,
      trainingPolicy: {
        id: 0,
        name: '',
        link: '',
        compulsory: false,
        version: '',
        videoID: '',
        object: '',
        type: 'link',
        file: '',
        currLink: '',
        enforce: false,
        policy_group_id: null,
      },
      buttonLbl: "Create",
      attestationRequirements: [
        {label:"Yes",value:true},
        {label:"No",value:false}
      ],
    };
  },

  mounted() {
    if (this.data != null) {
      this.trainingPolicy.id = this.data.ID
      this.trainingPolicy.name = this.data.name
      this.trainingPolicy.currLink = this.data.link
      this.trainingPolicy.link = this.data.link
      this.trainingPolicy.file = this.data.link
      this.trainingPolicy.compulsory = this.data.required
      this.trainingPolicy.version = this.data.version
      this.trainingPolicy.policy_group_id = this.data.policy_group_id
      this.buttonLbl = "Update"
      if (this.data.training_videos.length != 0) {
        this.trainingPolicy.videoID = this.data.training_videos[0].ID
      }
    }
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    },
    groups(newGroups, oldGroups) {
      // If a new group was added
      if (newGroups.length > oldGroups.length) {
        // Find the group that exists in the new list but not the old one
        const addedGroup = newGroups.find(ng => !oldGroups.some(og => og.ID === ng.ID));
        if (addedGroup) {
          this.handleGroupSelection(addedGroup);
        }
      }
    }
  },

  methods: {

    handleGroupSelection(selectedGroup) {
      this.trainingPolicy.policy_group_id = selectedGroup ? selectedGroup.ID : null;
    },

    fileHandler(files){
      // The FileUploader component will emit an empty string if the file is cleared.
      // Otherwise, it emits the file object.
      this.trainingPolicy.object = files;
      this.trainingPolicy.file = files;
    },

    async create() {
      this.$emit("onChange", { data: this.trainingPolicy });
      this.closeDialog();
    },

    truncatedLink(link) {
      const maxLength = 50;


      let truncated = link.substring(0, maxLength);
      if (link.length > maxLength) {
        truncated += '...';
      }

      return truncated;
    },

    closeDialog() {
      this.$emit("close");
      this.state = false;
    },

    disableFormButton() {
      if (this.v$.$invalid) {
        return true;
      }

      if (this.trainingPolicy.type === 'link') {
        return !this.trainingPolicy.link;
      }

      if (this.trainingPolicy.type === 'file') {
        // The file object from the uploader is nested.
        const file = this.trainingPolicy.file && this.trainingPolicy.file.files;
        // Disable if no file is present OR if the present file is not a PDF.
        return !file || file.type !== 'application/pdf';
      }

      return false;
    },

    switchType(newType) {
      this.trainingPolicy.type = newType;

      if (this.trainingPolicy.type === 'link') {
        this.trainingPolicy.file = this.trainingPolicy.link || '';
      } else if (this.trainingPolicy.type === 'file') {
        this.trainingPolicy.file = this.trainingPolicy.object || '';
      }

    },

  },

  computed: {
    showPdfError() {
      if (this.trainingPolicy.type !== 'file') {
        return false;
      }
      const file = this.trainingPolicy.file && this.trainingPolicy.file.files;
      // Show error only if a file is selected and it's not a PDF.
      // Don't show an error if no file is selected yet (file is falsy).
      return this.trainingPolicy.file && (!file || file.type !== 'application/pdf');
    }
  }
};
</script>

<style scoped>
/* START: FINAL DIMENSION UPDATE */

/* Label Styling */
.policy-type-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #00A0C1 !important;
  font-weight: 500;
}

/* Common button styles */
.btn-group .btn {
  height: 24px;
  padding: 0; /* Reset padding to center content in fixed-size box */
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out;
  border: 1px solid #ced4da;
  white-space: nowrap;
}

/* --- INDIVIDUAL BUTTON WIDTHS FROM FIGMA --- */
.btn-group .btn:first-child {
  width: 68px; /* Link button width */
}
.btn-group .btn:last-child {
  width: 79px; /* Upload button width */
}
/* ------------------------------------------- */


/* Active Button State */
.btn-group .btn.btn-policy-active {
  background-color: #28a7b9;
  border-color: #28a7b9;
  color: white;
  z-index: 2;
  font-weight: 700;
}

/* Inactive Button State */
.btn-policy-inactive {
  background-color: #ffffff;
  color: #556371;
}
.btn-policy-inactive:hover {
  background-color: #f8f9fa;
}

/* Correct Border Radius */
.btn-group > .btn:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.btn-group > .btn:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

/* END: FINAL DIMENSION UPDATE */


.modal__action {
  display: flex;
  justify-content: center;
}

form label:not(#compulsoryLbl){
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]), select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.btn-primary {
  border-radius: 10px;
  width: 120px;
  height: 40px;
}
</style>